import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';

import {
  PRODUCT_DEFINITIONS_FETCH,
  PRODUCTS_SELECTED_UNSET,
  PRODUCTS_SELECTED_JOB_ITEMS_ADD,
} from './products.module/types';
import {
  SERVICE_DEFINITIONS_FETCH,
  SERVICE_SELECTED_REFRESH,
  SERVICE_SELECTED_JOB_ITEMS_ADD,
} from './services.module/types';
import {
  READINESS_DATE,
  SERVICES,
  DELIVERY_DATE,
  PRODUCTS,
} from '../components/inputs/_types';

export const JOB_EDIT_CLEAR = 'JOB_EDIT_CLEAR',
  JOB_SET_EDIT = 'JOB_SET_EDIT',
  JOBS_ADD = 'JOBS_ADD',
  JOB_INIT_INPUTS = 'JOB_INIT_INPUTS',
  JOB_UPDATE_INPUT = 'JOB_UPDATE_INPUT',
  JOB_UPDATE_EXTRA_INPUT = 'JOB_UPDATE_EXTRA_INPUT',
  SET_JOB_FILTER = 'SET_JOB_FILTER',
  JOB_LOAD_INVOICING_TARGETS = 'JOB_LOAD_INVOICING_TARGETS';

export default {
  state: {
    edit: {},
    filters: {
      search: '',
      status: null,
      owner: null,
      test: false,
      useQuickSearch: false,
      useAdvancedSearch: false,
      advancedSearch: null,
      quickSearch: null,
    },
    inputs: {},
    constrains: {},
  },
  mutations: {
    [JOB_EDIT_CLEAR](state) {
      state.edit = {};
    },
    [JOB_SET_EDIT](state, payload) {
      if (payload && payload.jobId) {
        Vue.set(state.edit, payload.jobId, payload);
      }
    },
    [JOBS_ADD](state, payload) {
      state.edit = {
        ...state.edit,
        ...payload,
      };
    },
    [JOB_INIT_INPUTS](state, payload) {
      if (payload && payload.jobId) {
        Vue.set(state.inputs, payload.jobId, payload.inputs);
        if (payload.constrains) {
          Vue.set(state.constrains, payload.jobId, payload.constrains);
        }
      }
    },
    [JOB_UPDATE_INPUT](state, payload) {
      if (payload && payload.jobId && state.inputs[payload.jobId]) {
        if (payload.data?.pathBasedUpdate) {
          _.set(
            state.inputs[payload.jobId][payload.inputName].data,
            payload.data.path,
            payload.data.value,
          );
        } else {
          state.inputs[payload.jobId][payload.inputName].data = payload.data;
        }
        if (payload.edit !== undefined && payload.edit !== null) {
          state.inputs[payload.jobId][payload.inputName].edit = payload.edit;
        }
      }
    },
    [JOB_UPDATE_EXTRA_INPUT](state, payload) {
      if (payload && payload.jobId && state.inputs[payload.jobId]) {
        state.inputs[payload.jobId][payload.inputName].extra = payload.extra;
      }
    },
    [SET_JOB_FILTER](state, payload) {
      state.filters = {
        ...state.filters,
        ...payload,
      };
    },
    [JOB_LOAD_INVOICING_TARGETS](state, payload) {
      state.invoicingTargets = {
        ...state.invoicingTargets,
        [payload.jobId]: payload.invoicingTarget,
      };
    },
  },
  actions: {
    [JOBS_ADD]({ commit }, payload) {
      const payload_mutation = payload.reduce((jobs_acc, job) => {
        return {
          ...jobs_acc,
          [job.api_id]: {
            jobId: job.api_id,
            oemId: job.oem.oem_id,
            opportunity: job.opportunity,
          },
        };
      }, {});
      commit(JOBS_ADD, payload_mutation);
    },
    [JOB_SET_EDIT]({ commit, getters, dispatch }, payload) {
      if (payload.init === true) {
        const previousEditState = getters.jobEdit(payload.jobId);
        if (previousEditState) {
          payload = Object.assign(previousEditState, payload);
        }
        // clear previously selected properties for this job edit:
        dispatch(PRODUCTS_SELECTED_UNSET, { jobId: payload.jobId });
        dispatch(SERVICE_SELECTED_REFRESH, { jobId: payload.jobId });
        // return trigger set_edit with oemId, do it here better!!
        dispatch(PRODUCT_DEFINITIONS_FETCH, {
          context: payload.context,
          brand_id: payload.brandId,
          opportunity: payload.opportunity.sfid,
          jobId: payload.jobId,
        });
        dispatch(SERVICE_DEFINITIONS_FETCH, {
          useExternalNames: getters.useExternalNames,
          context: payload.context,
          opportunity: payload.opportunity.sfid,
        });
      }
      commit(JOB_SET_EDIT, payload);
    },
    [JOB_INIT_INPUTS]({ commit, dispatch }, payload) {
      const inputsByName = payload.inputs.reduce((acc, input) => {
        return {
          ...acc,
          [input.name]: input,
        };
      }, {});
      if (SERVICES in inputsByName) {
        dispatch(SERVICE_SELECTED_JOB_ITEMS_ADD, {
          jobId: payload.jobId,
          services: inputsByName[SERVICES].data,
        });
        inputsByName[SERVICES].data = null;
      }
      if (PRODUCTS in inputsByName) {
        dispatch(PRODUCTS_SELECTED_JOB_ITEMS_ADD, {
          jobId: payload.jobId,
          products: inputsByName[PRODUCTS].data,
        });
        inputsByName[PRODUCTS].data = null;
      }
      commit(JOB_INIT_INPUTS, {
        jobId: payload.jobId,
        inputs: inputsByName,
        constrains: payload.constrains,
      });
    },
    [JOB_UPDATE_INPUT]({ commit }, payload) {
      switch (payload.inputName) {
        case SERVICES:
          // All services updates should be handled in services module
          break;
        case PRODUCTS:
          // All products updates should be handled in products module
          break;
        default:
          commit(JOB_UPDATE_INPUT, payload);
          break;
      }
    },
    [JOB_UPDATE_EXTRA_INPUT]({ commit }, payload) {
      switch (payload.inputName) {
        case SERVICES:
          // All services updates should be handled in services module
          break;
        case PRODUCTS:
          // All products updates should be handled in products module
          break;
        default:
          commit(JOB_UPDATE_EXTRA_INPUT, payload);
          break;
      }
    },
    async [JOB_LOAD_INVOICING_TARGETS]({ commit }, payload) {
      const response = await axios.get(
        `/data-api/job-invoicing-targets/${payload.jobId}`,
      );

      commit(JOB_LOAD_INVOICING_TARGETS, {
        jobId: payload.jobId,
        invoicingTarget: response.data,
      });
    },
  },
  getters: {
    jobEdit(state) {
      return (jobId) => {
        if (jobId) {
          return state.edit[jobId];
        }
      };
    },
    jobOpportunity(state) {
      return (jobId) => {
        if (jobId && state.edit[jobId]) {
          return state.edit[jobId].opportunity;
        }
      };
    },
    jobInputDescription(state, getters) {
      return (jobId, inputName) => {
        const inputs = state.inputs[jobId];
        if (!inputs) {
          return;
        }
        const inputDescription = inputs[inputName];
        if (!inputDescription) {
          return;
        }
        switch (inputDescription.name) {
          case SERVICES:
            return {
              ...inputDescription,
              data: getters.allSelectedServices(jobId).map((service) => {
                const { productId, ...rest } = service;
                return {
                  ...rest,
                  product_id: productId,
                };
              }),
            };
          case PRODUCTS:
            return {
              ...inputDescription,
              data: getters.selectedProducts(jobId),
            };
          default:
            return inputDescription;
        }
      };
    },
    jobInputsDescriptions(state, getters) {
      return (jobId) => {
        return state.inputs[jobId]
          ? Object.keys(state.inputs[jobId]).map((inputName) =>
              getters.jobInputDescription(jobId, inputName),
            )
          : [];
      };
    },
    jobInputsAllValues(state, getters) {
      return (jobId) => {
        if (jobId) {
          return getters
            .jobInputsDescriptions(jobId)
            .reduce(
              (result, input) => ({ ...result, [input.name]: input.data }),
              {},
            );
        }
      };
    },
    jobInputsEditedValues(state, getters) {
      return (jobId) => {
        if (jobId) {
          return getters.jobInputsDescriptions(jobId).reduce(
            (result, input) =>
              input.edit
                ? {
                    ...result,
                    [input.name]: getters[`${input.name}/inputData`]
                      ? getters[`${input.name}/inputData`](jobId)
                      : input.data,
                  }
                : result,
            {},
          );
        }
      };
    },
    jobInputValue(state, getters) {
      return (jobId, inputName, key = undefined) => {
        if (jobId) {
          const inputDescription = getters.jobInputDescription(
            jobId,
            inputName,
          );
          if (inputDescription) {
            if (key !== undefined) {
              return inputDescription.data[key];
            }
            return inputDescription.data;
          }
        }
      };
    },
    jobInputsConstrainMinDate(state) {
      return (jobId) => {
        let dates = [
          _.get(state, `inputs.${jobId}.${READINESS_DATE}.data`),
          _.get(state, `inputs.${jobId}.${DELIVERY_DATE}.data`),
          _.get(state, `constrains.${jobId}.minDate`),
        ]
          .map((date) => moment(date))
          .filter((date) => date.isValid())
          .map((date) => date.startOf('day'))
          .sort((a, b) => a.diff(b));
        return dates.length > 0 ? dates.pop() : undefined;
      };
    },
    jobInvoicingTargets(state, getters) {
      return (jobId) => {
        return state.invoicingTargets?.[jobId];
      };
    },
  },
};
